import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface DashboardResponse {
  pending_leave_count: number;
  pending_trip_count: number;
}

export interface LeaveItem {
  leave_no: string;
  emp_no: string;
  emp_name: string;
  leave_type: string;
  leave_type_name: string;
  dept_code: string;
  start_date: string | null;
  end_date: string | null;
  hours: number;
  mgr_stat: string;  // F921_20
  vp_stat: string;   // F921_30
  reason: string;
  remarks: string;
  hr_stat: string;   // F921_40
}

export interface LeaveListResponse {
  items: LeaveItem[];
  total: number;
}

export interface TripItem {
  trip_no: string;
  emp_no: string;
  emp_name: string;
  dept_code: string;
  start_date: string | null;
  end_date: string | null;
  dest: string;
  mgr_stat: string;  // F924_20
  vp_stat: string;   // F924_80
  purpose: string;
  remarks: string;
}

export interface TripListResponse {
  items: TripItem[];
  total: number;
}

export interface ApproveResultItem {
  no: string;
  success: boolean;
  message: string;
  new_stat: string;
}

export interface ApproveResponse {
  results: ApproveResultItem[];
  success: number;
  failed: number;
  message: string;
}

export type ApproveAction = 'Y' | 'N' | 'P';

export interface LeaveApproveRequest {
  leave_nos: string[];
  action: ApproveAction;
  remarks: string;
}

export interface TripApproveRequest {
  trip_nos: string[];
  action: ApproveAction;
  remarks: string;
}

export interface EmpFilter {
  empStart: string;
  empEnd: string;
}

// ============================================================
// API methods
// ============================================================

export const p9513Api = {
  // GET /api/p9513/dashboard
  async getDashboard(): Promise<DashboardResponse> {
    const res = await apiClient.get('/api/p9513/dashboard');
    return res.data;
  },

  // GET /api/p9513/leaves?empStart=&empEnd=
  async getLeaves(filter: EmpFilter): Promise<LeaveListResponse> {
    const res = await apiClient.get('/api/p9513/leaves', {
      params: { empStart: filter.empStart, empEnd: filter.empEnd },
    });
    return res.data;
  },

  // POST /api/p9513/leaves/approve
  async approveLeaves(req: LeaveApproveRequest): Promise<ApproveResponse> {
    const res = await apiClient.post('/api/p9513/leaves/approve', req);
    return res.data;
  },

  // GET /api/p9513/trips?empStart=&empEnd=
  async getTrips(filter: EmpFilter): Promise<TripListResponse> {
    const res = await apiClient.get('/api/p9513/trips', {
      params: { empStart: filter.empStart, empEnd: filter.empEnd },
    });
    return res.data;
  },

  // POST /api/p9513/trips/approve
  async approveTrips(req: TripApproveRequest): Promise<ApproveResponse> {
    const res = await apiClient.post('/api/p9513/trips/approve', req);
    return res.data;
  },
};
